module.exports = __webpack_public_path__ + "img/close_error.77f18c92.svg";